import {
  DATE_RANGES,
  DEFAULT_LATEST_N,
  TRAINING_COUNT_RANGES,
} from "../AddWidgetModal/constants";

// Field types are intentionally loose (string / string | null) so every widget's
// builder-misc shape is accepted, including Table2D's less-strict variant.
interface DateFields {
  showAdvancedDate?: boolean;
  startDateType?: string;
  startDateAbsolute?: string | null;
  startDateOffset?: number;
  startDateLatestN?: number;
  endDateType?: string;
  endDateAbsolute?: string | null;
  endDateOffset?: number;
  dateRange?: string;
  /** Chart/pie series builder-misc stores the preset under this name instead. */
  dateRangePreset?: string;
}

const relativeLabel = (offset?: number) =>
  offset == null || offset === 0 ? "today" : `${offset}d`;

/** The end of the window alone: "today", "-3d" or an absolute date. A preset always ends today. */
export function resolveDateEnd(fields?: DateFields): string {
  if (!fields?.showAdvancedDate) return "today";
  return fields.endDateType === "absolute" && fields.endDateAbsolute
    ? fields.endDateAbsolute
    : relativeLabel(fields.endDateOffset);
}

export function resolveDateRange(fields?: DateFields): string {
  if (fields?.showAdvancedDate) {
    // The dates behind a latest_n window are only known once the backend has resolved it
    // against the data, so the picker names the window rather than guessing a range.
    if (fields.startDateType === "latest_n") {
      const n = fields.startDateLatestN ?? DEFAULT_LATEST_N;
      // The window always ends today, so there is no end to name.
      return `Last ${n} session${n === 1 ? "" : "s"}`;
    }
    const start =
      fields.startDateType === "absolute" && fields.startDateAbsolute
        ? fields.startDateAbsolute
        : relativeLabel(fields.startDateOffset);
    return `${start} to ${resolveDateEnd(fields)}`;
  }
  const preset = fields?.dateRange ?? fields?.dateRangePreset;
  return DATE_RANGES.find((d) => d.value === preset)?.label
    ?? TRAINING_COUNT_RANGES.find((d) => d.value === preset)?.label
    ?? preset ?? "Default";
}
